import { editorialStatusBlock, button } from "../../design/components.js";
import { LAUNCH_LOCALES, type Locale } from "../../i18n/catalog.js";

export interface PromiseCtx {
  t: (k: string, p?: Record<string, string | number>) => string;
  onNext: () => void;
  onRestore: () => void;
  /** Inline locale override (onboarding spec §5; auto-detected, switchable inline). */
  current?: Locale;
  onLocale?: (l: Locale) => void;
}

/** Onboarding screen 1 — Promise. Tagline + re-sourced community proof strip +
 *  the always-visible inline locale switcher (onboarding spec §5). */
export function promiseScreen(ctx: PromiseCtx): HTMLElement {
  const root = document.createElement("section");
  root.className = "screen onboarding-promise";

  if (ctx.onLocale) {
    const switcher = document.createElement("div");
    switcher.className = "locale-switcher";
    switcher.setAttribute("role", "group");
    switcher.setAttribute("aria-label", ctx.t("locale.switch"));
    for (const loc of LAUNCH_LOCALES) {
      const b = button({ label: loc, variant: ctx.current === loc ? "primary" : "secondary", onClick: () => ctx.onLocale!(loc) });
      b.setAttribute("data-locale", loc);
      b.setAttribute("aria-pressed", String(ctx.current === loc));
      switcher.append(b);
    }
    root.append(switcher);
  }

  root.append(
    editorialStatusBlock({
      microlabel: ctx.t("onboarding.promise.step"),
      headline: ctx.t("onboarding.promise.tagline"),
    }),
  );

  const proof = document.createElement("ul");
  proof.className = "promise-proof";
  for (const key of [
    "onboarding.promise.proof.corroboration",
    "onboarding.promise.proof.time",
    "onboarding.promise.proof.nosignup",
  ]) {
    const li = document.createElement("li");
    li.className = "bx-microlabel";
    li.setAttribute("data-proof", "");
    li.textContent = ctx.t(key);
    proof.append(li);
  }
  root.append(proof);

  const next = button({ label: ctx.t("onboarding.promise.continue"), variant: "primary", onClick: ctx.onNext });
  next.setAttribute("data-action", "next");
  next.setAttribute("aria-label", ctx.t("onboarding.promise.continue"));

  const restore = button({ label: ctx.t("onboarding.promise.restore"), variant: "secondary", onClick: ctx.onRestore });
  restore.setAttribute("data-action", "restore");
  restore.setAttribute("aria-label", ctx.t("onboarding.promise.restore"));

  root.append(next, restore);
  return root;
}
